<style lang="scss">
    .common-fuzzy {
        .ls-table-block {
            padding: 0;
            margin: 0;
        }

        .el-dialog__body {
            padding: 0 20px;
        }
        .ls-table {
            min-height: 350px;
        }
        .el-form-item {
            margin-bottom: 0;
        }
        .el-form-item__label {
            font-size: 14px;
            line-height: 40px;
        }
        .el-form-item__content {
            font-size: 12px;
            line-height: 40px;
            input {
                line-height: 24px;
                height: 24px;
            }
        }
    }
</style>
<template>

    <my-front-table-comment ref="table" :com-api="comApi" :cols="comCols" :data="list" :loading="loading" :page-param="page"  hide-multiple
              @init="init" :headId="headId" @refresh="getList" @pageChange="pageChange" @paramChange="paramChange" :height="null"
              @cndClusterChange="cndClusterChange" @handleRowDbClickChange="handleDb">
    </my-front-table-comment>
</template>

<script>
    // import axios from '@/util/api'
    // import help from '@/util/help'
    import tableMixin from '@/util/tableMixin'
    import MyFrontTableComment from "@/components/MyFrontTableComment";


    export default {
        components: {MyFrontTableComment},
        mixins: [tableMixin],
        props: {
            comApi:{

            },
            comCols: {
                type: Array,
                default: () => {
                    return []
                }
            },
            headId: {
                type: String,
            },
        },
        data() {
            return {
                api: {
                    list: '',   // 列表接口
                },
                cols: [],
                query: {
                    headId : '',
                },
                queryFunc: () => {},
            }
        },
        created() {
            this.api.list = this.comApi.list;
            this.cols = this.comCols.map(item => {
                item.viewList = true
                return item
            })
            if (this.headId) {
                this.query.headId = this.headId
            }

            // if (this.obj.query) {
            //     this.queryFunc = this.obj.query
            // }

        },
        methods: {
            handleDb(data) {
                this.$emit('change', data)
            },

        }
    }
</script>
